module.exports = __webpack_public_path__ + "img/0xb8C540d00dd0Bf76ea12E4B4B95eFC90804f924E.fa92d0aa.png";